import { ApiResponse, Service } from '@repo/core'
import { GlobalPositionResponse } from '@repo/position-types'
import { AxiosRequestConfig } from 'axios'

export interface GlobalPositionParams {
  currency?: string
  date?: string
  interventionType?: string
}

export const getGlobalPosition: Service<
  GlobalPositionParams,
  ApiResponse<GlobalPositionResponse>,
  Pick<AxiosRequestConfig, 'signal'>
> = async ({ api, params, accept, config }) => {
  return api.get<ApiResponse<GlobalPositionResponse>>('/position', {
    params,
    ...config,
    ...(accept && { headers: { Accept: accept }, responseType: 'blob' as const }),
  })
}
